import { render, staticRenderFns } from "./ParentGuardianDialog.vue?vue&type=template&id=59787a88"
import script from "./ParentGuardianDialog.vue?vue&type=script&lang=js"
export * from "./ParentGuardianDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports